(function () {
	const header = () => {
		const body = document.querySelector("body");
		const header = document.querySelector(".shopify-section-header");
		const headerDetails = document.querySelector(".menu-drawer-container");
		const headerIsAlwaysSticky =
			header
				.querySelector(".header-wrapper")
				.getAttribute("data-sticky-type") === "always";

		headerDetails.addEventListener("toggle", function (e) {
			const colorScheme =
				this.querySelector("#menu-drawer").dataset.colorScheme;
			header.classList.toggle(colorScheme);
		});

		document.addEventListener("keyup", (e) => {
			if (e.key === "Escape") {
				header.classList.remove("shopify-section-header-sticky", "animate");
				body.classList.remove("overflow-hidden");
			}
		});

		document.addEventListener("scroll", () => {
			let scrollTop = window.scrollY;
			if (scrollTop > header.offsetHeight && headerIsAlwaysSticky) {
				header.classList.add("fixed", "animate");
			} else if (scrollTop <= header.offsetHeight && headerIsAlwaysSticky) {
				header.classList.remove("fixed", "animate");
			}
		});

		const addBackground = () => {
			if (
				header.classList.contains("color-inverse") &&
				!header.classList.contains("shopify-section-header-sticky")
			) {
				header.classList.remove("color-inverse");
			}
		};

		const removeBackground = () => {
			if (document.body.classList.contains("overflow-hidden-tablet")) {
				return;
			}

			if (
				header.classList.contains("header-overlay") &&
				!header.classList.contains("shopify-section-header-sticky")
			) {
				header.classList.add("color-inverse");
			}
		};

		header.addEventListener("mouseenter", addBackground);

		header.addEventListener("focus", addBackground);

		header.addEventListener("focusin", addBackground);

		header.addEventListener("mouseleave", removeBackground);

		header.addEventListener("focusout", removeBackground);

		initClickMegaMenu();
	};

	const initClickMegaMenu = () => {
		if (document.documentElement.dataset.clickMegaMenu === "true") return;
		document.documentElement.dataset.clickMegaMenu = "true";

		const resetMegaMenuPanels = (root) => {
			if (!root) return;
			const alle = root.querySelector('[data-mega-panel="alle-produkte"]');
			root.querySelectorAll("[data-mega-panel]").forEach((panel) => {
				panel.classList.add("is-hidden");
			});
			root.querySelectorAll("[data-mega-panel-default]").forEach((panel) => {
				panel.classList.toggle("is-hidden", Boolean(alle));
			});
			if (alle) alle.classList.remove("is-hidden");
			root.querySelectorAll("[data-mega-panel-trigger]").forEach((item) => {
				item.classList.toggle(
					"is-active",
					Boolean(alle) && item.getAttribute("data-mega-panel-trigger") === "alle-produkte"
				);
			});
		};

		const panelIdFrom = (node) => {
			if (!node || !node.closest) return "";
			const trigger = node.closest("[data-mega-panel-trigger]");
			if (trigger) return trigger.getAttribute("data-mega-panel-trigger");
			const panel = node.closest("[data-mega-panel]");
			if (panel) return panel.getAttribute("data-mega-panel");
			return "";
		};

		const showMegaMenuPanel = (menu, id) => {
			if (!id) return;
			const panel = menu.querySelector('[data-mega-panel="' + id + '"]');
			menu.querySelectorAll("[data-mega-panel]").forEach((node) => node.classList.add("is-hidden"));
			menu.querySelectorAll("[data-mega-panel-default]").forEach((node) => node.classList.add("is-hidden"));
			if (panel) panel.classList.remove("is-hidden");
			menu.querySelectorAll("[data-mega-panel-trigger]").forEach((item) => {
				item.classList.toggle("is-active", item.getAttribute("data-mega-panel-trigger") === id);
			});
		};

		const setOpen = (item, isOpen) => {
			const trigger = item.querySelector("[data-mega-menu-trigger]");
			item.classList.toggle("is-open", isOpen);
			if (trigger) trigger.setAttribute("aria-expanded", isOpen ? "true" : "false");
			if (!isOpen) resetMegaMenuPanels(item);
		};

		const closeAll = (except) => {
			document.querySelectorAll(".header .mega-menu--click.is-open").forEach((item) => {
				if (except && item === except) return;
				setOpen(item, false);
			});
		};

		document.addEventListener("click", (event) => {
			const trigger = event.target.closest("[data-mega-menu-trigger]");
			if (trigger) {
				event.preventDefault();
				const item = trigger.closest(".mega-menu--click");
				if (!item) return;
				const willOpen = !item.classList.contains("is-open");
				closeAll();
				if (willOpen) setOpen(item, true);
				return;
			}

			closeAll(event.target.closest(".mega-menu--click.is-open"));
		});

		document.addEventListener("keyup", (event) => {
			if (event.key !== "Escape") return;
			const openItem = document.querySelector(".header .mega-menu--click.is-open");
			if (!openItem) return;
			const trigger = openItem.querySelector("[data-mega-menu-trigger]");
			setOpen(openItem, false);
			if (trigger) trigger.focus();
		});

		document.addEventListener("focusin", (event) => {
			document.querySelectorAll(".header .mega-menu--click.is-open").forEach((item) => {
				if (item.contains(event.target)) return;
				setOpen(item, false);
			});

			const menu = event.target.closest(".header-mega-menu");
			if (!menu) return;
			const id = panelIdFrom(event.target);
			if (id) showMegaMenuPanel(menu, id);
			else resetMegaMenuPanels(menu);
		});

		document.addEventListener("pointerover", (event) => {
			const id = panelIdFrom(event.target);
			if (!id) return;
			const menu = event.target.closest(".header-mega-menu");
			if (!menu) return;
			showMegaMenuPanel(menu, id);
		});

		document.addEventListener("pointerout", (event) => {
			const menu = event.target.closest(".header-mega-menu");
			if (!menu) return;
			const active = menu.querySelector("[data-mega-panel-trigger].is-active");
			if (!active) return;
			const related = event.relatedTarget;
			const id = active.getAttribute("data-mega-panel-trigger");
			if (related && related.closest) {
				if (active.contains(related)) return;
				if (related.closest('[data-mega-panel="' + id + '"]')) return;
				if (related.closest(".header-mega-menu__panel-column")) return;
			}
			resetMegaMenuPanels(menu);
		});

		window.addEventListener(
			"scroll",
			() => {
				closeAll();
			},
			{ passive: true }
		);
	};

	header();

	document.addEventListener("shopify:section:load", header);
	document.addEventListener("shopify:section:unload", header);
	document.addEventListener("shopify:section:reorder", header);
})();
